/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SortExpression } from './sort-expression';
import { WorkerStatuses } from './worker-statuses';
import { DateTimePeriod } from './date-time-period';


export interface ExportWorkersRequest { 
    accountId?: string | null;
    miningProductId: number;
    statusIds?: Array<WorkerStatuses> | null;
    groupIds?: Array<string> | null;
    upTimePeriod?: DateTimePeriod;
    workerNameKeyword?: string | null;
    sortExpressions?: Array<SortExpression> | null;
}

